import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SortAscendingLettersIcon = function SortAscendingLettersIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SortAscendingLettersIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.725 3.333c0-.367.084-.474.11-.499.024-.025.13-.109.498-.109s.474.084.5.11c.024.024.109.13.109.498v.609h-1.217zm2.667 0v3.334a.725.725 0 0 1-1.45 0V5.392h-1.217v1.275a.725.725 0 0 1-1.45 0V3.333c0-.552.122-1.112.534-1.524s.972-.534 1.524-.534c.553 0 1.113.122 1.525.534s.534.972.534 1.524M10 8.608a.725.725 0 0 0 0 1.45h1.417L9.37 13.64a.725.725 0 0 0 .63 1.085h2.667a.725.725 0 1 0 0-1.45h-1.418l2.047-3.582a.725.725 0 0 0-.63-1.085zm-7.846.88a.725.725 0 0 1 1.025 0l.762.762V4a.725.725 0 0 1 1.45 0v6.25l.763-.763a.725.725 0 1 1 1.025 1.026l-2 2a.723.723 0 0 1-1.025 0l-2-2a.725.725 0 0 1 0-1.026",
      clipRule: "evenodd"
    })
  }));
};

export { SortAscendingLettersIcon };
